import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df3237f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time-line-box" }
const _hoisted_2 = { class: "swiper-container text-center" }
const _hoisted_3 = { class: "swiper-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-slide" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "timestamp" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "spacer" }, " .")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "status" })
], -1))
const _hoisted_5 = { class: "div" }
const _hoisted_6 = {
  key: 0,
  class: "swiper-slide"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timestamp" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spacer" }, " .")
], -1))
const _hoisted_8 = { class: "status" }
const _hoisted_9 = { class: "fw-bold" }
const _hoisted_10 = {
  key: 1,
  class: "swiper-slide"
}
const _hoisted_11 = { class: "timestamp" }
const _hoisted_12 = { class: "fw-bold" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-slide" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "timestamp" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "spacer" }, " .")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "status" })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimelineCard = _resolveComponent("TimelineCard")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.awards, (data, index) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (index%2 == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(data.date), 1)
                  ]),
                  _createVNode(_component_TimelineCard, {
                    class: "my-4",
                    id: data.id,
                    date: data.date,
                    title: data.description,
                    "img-url": data.image,
                    content: data.content
                  }, null, 8, ["id", "date", "title", "img-url", "content"])
                ]))
              : _createCommentVNode("", true),
            (index%2 == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(data.date), 1)
                  ]),
                  _hoisted_13,
                  _createVNode(_component_TimelineCard, {
                    class: "timeline-article-top",
                    id: data.id,
                    date: data.date,
                    title: data.description,
                    "img-url": data.image,
                    content: data.content
                  }, null, 8, ["id", "date", "title", "img-url", "content"])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 256)),
        _hoisted_14
      ]),
      _hoisted_15
    ])
  ]))
}